import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const DateSvgIcon = () => {
    return (
        <SvgIcon
        sx={{
            width:'10px',
            height:'10px '
        }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 10"
            >
                <path
                    fill="#B0AFB1"
                    d="M1.5 10a.963.963 0 01-.706-.294A.963.963 0 01.5 9V2c0-.275.098-.51.294-.706A.963.963 0 011.5 1H2V0h1v1h4V0h1v1h.5c.275 0 .51.098.706.294A.963.963 0 019.5 2v7c0 .275-.098.51-.294.706A.963.963 0 018.5 10h-7zm0-1h7V4h-7v5zm0-6h7V2h-7v1z"
                ></path>
            </svg>
        </SvgIcon>
    );
};

export default DateSvgIcon;